import { Details, NerdWalletBadge } from '@ria-client/tw-shared-ui';
import { ChevronDown } from 'lucide-react';
import { useId } from 'react';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';

export function SMBWhyTrustNerdWallet({
  props,
}: NodeProps<{ children: StructuredContentDocument }>) {
  const panelId = `panel-content-smb-why-trust-nerdwallet-${useId()}`;

  return (
    <Details
      variant="simple"
      className="border border-border"
      SummaryComponent={
        <>
          <span className="m-1 flex items-center gap-2 pl-2">
            <NerdWalletBadge />
            <span className="typography-text-bold">Why trust NerdWallet</span>
          </span>
          <ChevronDown
            aria-hidden
            className="expand-icon size-[30px] text-[var(--content-neutral-dark)]"
          />
        </>
      }
      summaryComponentProps={{
        className:
          'flex items-center justify-between px-2 py-3 hover:bg-secondary sm:hover:outline-2 sm:hover:outline-[var(--content-blue-focus-outline)]',
        'aria-controls': panelId,
      }}
    >
      <div id={panelId} className="p-3">
        <StructuredContentRenderer doc={props.children} />
      </div>
    </Details>
  );
}
